import React, { Component } from "react";
import { get, isString } from "lodash";
import {
  dateFormat,
  isValidArray,
  getColor,
  getLocalstorage,
  replaceCharacterWith
} from "../../helper";
import { PreNode, ReadMore, RedirectUser } from "../reusableComponent";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import { connect } from "react-redux";
import attachmentIcon from "../../assets/attachment-icon.svg";

class MOMDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getMeetingStatusColor = type => {
    const colorCode = {
      "under consideration": "state-color-orange",
      "under process": "state-color-purple",
      "under decision": "state-color-blue",
      "on hold": "state-color-yellow",
      hold: "state-color-yellow",
      "under verification": "state-color-juniper",
      verified: "state-color-green",
      duplicate: "state-color-orange",
      resolved: "state-color-green",
      juniper: "state-color-juniper",
      rejected: "state-color-red",
      reject: "state-color-red",
      "pending with rm/rs": "state-color-purple"
    };
    return colorCode[isString(type) && type.toLowerCase()] || "color-blue";
  };

  renderTasks = () => {
    const { meeting } = this.props;
    const tasks = ["task1", "task2"];
    const renderedTasks = [];

    for (const task of tasks) {
      if (meeting[task]) {
        renderedTasks.push(
          <li key={task}>
            {meeting[task]}
            <p>
              Completion Date:{" "}
              <span>
                {(meeting[`${task}CompletionDate`] &&
                  dateFormat(meeting[`${task}CompletionDate`])) ||
                  "NA"}
              </span>
            </p>
          </li>
        );
      }
    }

    if (renderedTasks.length > 0) {
      return (
        <div className="issue-state issue-state">
          <ol className="ol-list">{renderedTasks}</ol>
        </div>
      );
    }

    return null;
  };

  render() {
    const { readMore, meeting, projectData, issueData } = this.props;
    // console.log(issueData)
    let projectId = get(projectData, "data.id", null);

    let duplicateIssues = get(issueData, "data.duplicateIssues") || [];
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    //console.log(userInfo.id)
    let data = get(issueData, "data", null);
    // console.log(data)
    const status = replaceCharacterWith(
      get(data, "issueStatusName", "NA"),
      "_",
      " "
    );
    return (
      <React.Fragment>
        <div className="mom-desc">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h4>Minutes of Meeting</h4>
            <div
              className={`${getColor(
                get(meeting, "issueStatus", "").toLowerCase()
              )} decision-status-container unClickable`}
            >
              <p>{get(meeting, "issueStatus", "NA")}</p>
            </div>
          </div>
          <div className="mom-data">
            <p className="m-0">
              <PreNode classes="pre-node-decision">
                <ReadMore
                  clamp={5}
                  content={get(meeting, "meetingDescription", "NA")}
                />
              </PreNode>
            </p>
            {(isValidArray(get(meeting, "actionItemDTOList", [])) && (
              <div className="action-item-wrapper">
                <b>Action Items:</b>
                <ul>
                  {(get(meeting, "actionItemDTOList", null) || []).map(
                    (actionItem, index) => (
                      <li key={`${index}-li`}>
                        <label>
                          Assign to - {get(actionItem, "assignToName", "NA")} |
                          Target Completion Date -{" "}
                          {dateFormat(
                            get(actionItem, "completionDate", "NA")
                          ) || "Not decided yet"}
                        </label>
                        <span>{get(actionItem, "description", "NA")}</span>
                      </li>
                    )
                  )}
                </ul>
                {readMore ? <span className="read-more">Read Less</span> : ""}
              </div>
            )) ||
              null}
            <div className="next-meeting-date">
              <label>Issue Resolution Date:</label>{" "}
              <span>
                {(get(meeting, "taskCompletionDate") &&
                  dateFormat(get(meeting, "taskCompletionDate"))) ||
                  "NA"}
              </span>
            </div>
            {this.renderTasks() && (
              <div>
                <div className="intermediate-tasks-wrapper">
                  <h4>Intermediate Tasks</h4>
                </div>
                <div className="issue-state-wrapper">{this.renderTasks()}</div>
              </div>
            )}
            <div className="agenda-decision-container">
              {isValidArray(get(meeting, "fileDTOList")) ? (
                <div className="meeting-attachments">
                  <img
                    src={attachmentIcon}
                    alt="attachment icon"
                    className="mr-1"
                  />
                  {get(meeting, "fileDTOList", []).map((val, index) => {
                    return (
                      <a
                        href={val.s3Url}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {val.title}
                        {index < get(meeting, "fileDTOList", []).length - 1
                          ? ", "
                          : ""}{" "}
                      </a>
                    );
                  })}
                </div>
              ) : null}
              <div className="show-date-status d-flex ml-auto">
                {get(meeting, "decisionCreatedBy", "NA") == null ? (
                  <></>
                ) : (
                  <>
                    <div className="decision-submission-date">
                      <span class="issue-created-by verified-user" />
                      <span class="first-pp-name">
                        <span class="issue-creator-name  text-left">
                          <RedirectUser
                            title={get(meeting, "decisionCreatedBy", "NA")}
                            id={
                              isUserPMG == false
                                ? get(meeting, "decisionCreatedById", "NA")
                                : get(meeting, "decisionCreatedById", "NA")
                            }
                          />
                        </span>
                      </span>
                    </div>
                  </>
                )}

                <div
                  className={
                    get(meeting, "decisionCreatedBy", "NA") == null
                      ? null
                      : "decision-submission-date issue-id-wrapper decision-left-border"
                  }
                >
                  Decision Submitted on :{" "}
                  {dateFormat(get(meeting, "decisionSubmittedOn", null))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectData: state.projectDetailsReducer.projectData,
    issueData: state.issueDetailsReducer.issueData
  };
}

export default connect(
  mapStateToProps,
  null
)(MOMDesc);
